import { fetcher } from "helpers/fetcher";

import { TGetEmployeePostRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEmployeePost = async (language: string) => {
  return await fetcher<TGetEmployeePostRes, any>(
    ENDPOINT.USER.GET_EMPLOYEE_POST,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_EMPLOYEE_POST.version,
        [API_HEADER.LANGUAGE]: language,
      },
    }
  );
};

export const queryGetEmployeePost = async (language: string) => {
  return (await getEmployeePost(language)).data;
};

queryGetEmployeePost._key = (language: string) => [
  ENDPOINT.USER.GET_EMPLOYEE_POST.url,
  language,
];
